module.exports = __webpack_public_path__ + "img/XButton.8d45d017.svg";